<template>
  <div class="no-data mobile">
    <NuxtImg
      format="webp"
      src="/assets/images/icons/news-no-data.png"
      class="mb-3"
      alt="Icon News"
      width="80"
      height="80"
      densities="1x"
      preload
    />
    <div class="no-data__title">Tin tức đang được cập nhật</div>
    <div class="no-data__desc">Hệ thống đang cập nhật tin tức, vui lòng thử lại sau!</div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/components/common/no-data.scss';
</style>
